import { Component } from '@angular/core';

/** Coquille hôte : barre de titre (vente) + ajout/modification client bibliothèque. */
@Component({
  selector: 'app-add-client-shell',
  template: '<app-title-section></app-title-section><router-outlet></router-outlet>'
})
export class AddClientShellComponent {}
